import { yellow, light } from "./constants";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { Button } from "reactstrap";
import { createRoot } from "react-dom/client";
import { heicTo, isHeic } from "heic-to";

export const renderStars = (value, showValue = true) => {
  const stars = [1, 2, 3, 4, 5].map((star) => {
    let starClass = "fa-star"; // default full star
    let color = light; // default empty star

    if (star <= Math.floor(value)) {
      starClass = "fa-star"; // full star
      color = yellow;
    } else if (star - 0.5 <= value) {
      starClass = "fa-star-half-alt"; // half star
      color = yellow;
    }

    return (
      <i key={star} className={`fa ${starClass} mr-1`} style={{ color }} />
    );
  });

  if (showValue && value != null && value !== "") {
    stars.push(
      <span key="val" className="ml-1">
        ({value})
      </span>
    );
  }

  return <div className="d-flex align-items-center">{stars}</div>;
};

export const showAlert = ({
  title = "",
  message = null, // JSX support
  type = "",
  confirmText = "Yes",
  cancelText = "Cancel",
  confirmStyle = "danger",
  cancelStyle = "secondary",
  showCancel = true,
  onConfirm = () => { },
  onCancel = () => { },
  children = null,
  closeOnConfirm = true,
  allowOutsideClick = false,
  showConfirm = true,
}) => {
  const container = document.createElement("div");
  const root = createRoot(container);
  document.body.appendChild(container);
  let isCancelTriggered = false;

  const handleClose = () => {
    root.unmount();
    container.remove();
  };

  const handleConfirm = async () => {
    if (closeOnConfirm) {
      handleClose();
    }
    await onConfirm(handleClose);
  };

  const handleCancel = () => {
    handleClose();
    onCancel();
  };

  const handleCancelClick = () => {
    isCancelTriggered = true;
    handleClose();
    onCancel();
  };

  const handleCloseOnly = () => {
    handleClose();
  };

  root.render(
    <ReactBSAlert
      warning={type === "warning"}
      success={type === "success"}
      info={type === "info"}
      title={<p className="small-text">{title}</p>}
      onConfirm={handleConfirm}
      onCancel={handleCloseOnly}
      showCancel={false}
      // confirmBtnBsStyle={confirmStyle}
      // cancelBtnBsStyle={cancelStyle}
      // confirmBtnText={confirmText}
      // cancelBtnText={cancelText}
      // showCancel={showCancel}
      // showConfirm={showConfirm}
      allowOutsideClick={allowOutsideClick}
      btnSize=""
      customButtons={
        <>
          {showCancel && (
            <button
              className={`btn btn-${cancelStyle} ml-2`}
              onClick={handleCancelClick}
            >
              {cancelText}
            </button>
          )}
          {showConfirm && (
            <button
              className={`btn btn-${confirmStyle}`}
              onClick={handleConfirm}
            >
              {confirmText}
            </button>
          )}
        </>
      }
    >
      {message}
      {children}
    </ReactBSAlert>
  );
  return handleClose;
};

// It's common function used for button structure in job module, later we can use it in other modules also
export const ActionButton = ({
  color = "default",
  icon,
  label,
  onClick,
  circle,
}) => (
  <>
    <Button
      color={color}
      size="sm"
      className={`mr-2 mb-2 ${circle ? "quotation-download-btn rounded-circle shadow-sm" : ""
        }`}
      onClick={onClick}
    >
      <i className={`fa ${icon} ${!circle && label ? "mr-1" : ""} fa-lg`} />
      {!circle && label}
    </Button>
  </>
);

export const authorizedUser = (res) => {
  if (res?.code === 440) {
    localStorage.clear();
    window.location.href = `/auth/login?error=Your session has expired`;
  } else {
    return;
  }
};

export const renderPriority = (value) => {
  const colorClass =
    value === "HIGH"
      ? "priority-high"
      : value === "MEDIUM"
        ? "priority-medium"
        : "priority-low";

  return (
    <div className="priority-container">
      <span className={`priority-circle ${colorClass}`} />
      <span>{value}</span>
    </div>
  );
};

//format date  of ISO -> proper format (yyyy-MM-dd)
export const formatDateLocal = (date) => {
  const year = date.getFullYear(); // 2025
  const month = String(date.getMonth() + 1).padStart(2, "0"); // as month start from 0 jan = 0 +1 =>  1
  const day = String(date.getDate()).padStart(2, "0"); // 0-31 date  //if 1 => 01
  return `${year}-${month}-${day}`; //2025/12/01
};

export const ISOToHumanReadableDate = (dateStr) => {
  const date = new Date(dateStr);

  let formatted = date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  // Uppercase only AM/PM, not month
  formatted = formatted.replace(/\b(am|pm)\b/i, (m) => m.toUpperCase());

  return formatted; // e.g., 18 Sep 2025 09:00 AM
};

//while adding new job format required
export const formatDate = (date) => {
  if (!date) return null;
  return new Date(date).toISOString().split("T")[0];
  // extract date from date objectt -> in this format YYYY-MM-DD
};

export const formatDateTime = (date) => {
  if (!date) return null;

  const d = new Date(date);
  const pad = (n) => String(n).padStart(2, "0");

  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
  //extract  YYYY-MM-DD HH:MM:SS from date object
};

// Format date with current time in ISO standard (YYYY-MM-DDTHH:mm:ssZ)
export const formatDateWithTZ = (date) => {
  if (!date) return null;

  const inputDate = new Date(date); // user selected date
  const now = new Date(); // current time for HH:mm:ss

  inputDate.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), 0);

  // Convert to ISO string → "2025-01-10T15:42:25.000Z"
  // Then remove milliseconds
  return inputDate.toISOString().replace(/\.\d{3}Z$/, "Z");
};

//"01 Dec 2023" → "2023-12-01"
export const convertUIToISODate = (dateStr) => {
  if (!dateStr || dateStr === "01 Jan 0001") return "";

  const months = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };

  // Split "01 Dec 2023"
  const [day, mon, year] = dateStr.split(" ");

  return `${year}-${months[mon]}-${day}`;
};

// Adds N years to a given ISO date (YYYY-MM-DD) → returns YYYY-MM-DD
export const addYearsToISODate = (dateStr, years = 2) => {
  if (!dateStr) return "";

  const d = new Date(dateStr);
  d.setFullYear(d.getFullYear() + years);

  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");

  return `${yyyy}-${mm}-${dd}`;
};

export const formatSAR = (value) => {
  if (value === null || value === undefined || isNaN(value)) {
    return "0.00";
  }

  return Number(value).toLocaleString("en-SA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatTime = (date) => {
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}:00`;
};

export const getOneHourAheadTime = (date) => {
  if (!date) return null;
  return new Date(new Date(date).getTime() + 60 * 60 * 1000);
};

export const convertHeicIfNeeded = async (file) => {
  const heicFile = await isHeic(file);

  if (!heicFile) {
    return file;
  }

  const jpegBlob = await heicTo({
    blob: file,
    type: "image/jpeg",
    quality: 0.9,
  });

  return new File(
    [jpegBlob],
    file.name.replace(/\.(heic|heif)$/i, ".jpg"),
    { type: "image/jpeg" }
  );
};

export const toTitleCase = (str = "") =>
  String(str).replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase(),
  );